import { EditorState, Modifier } from 'draft-js';
import { Map } from 'immutable';

var mergeBlockData = function mergeBlockData(editorState, data) {
  var content = editorState.getCurrentContent();
  var selection = editorState.getSelection();
  var newContent = Modifier.mergeBlockData(content, selection, Map(data));
  return EditorState.push(editorState, newContent, 'change-block-data');
};

export default mergeBlockData;